import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Routes } from 'src/routes';
import { routingOnRouteRequest } from 'src/app/store/routingSlice';
import { Box, Button, buttonClasses, Typography } from '@mui/material';
import EmptyStateGraphic from './empty-state.png';
import PaperCard from 'src/components/PaperCard';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';

type Props = ReturnType<typeof mapDispatchToProps>;

const ReceiptsEmptyView: FC<Props> = ({ goToInboxes }) => {
  return (
    <PaperCard sx={{ alignItems: 'center', py: 5 }}>
      <Box display="flex" flexDirection="column" gap={1} alignItems="center">
        <Box
          component="img"
          src={EmptyStateGraphic}
          sx={{
            filter:
              'sepia(100%) hue-rotate(60deg) brightness(75%) saturate(200%)',
            width: ({ spacing }) => spacing(15.625),
            height: ({ spacing }) => spacing(15.625),
          }}
        />
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h6" fontSize={14} fontWeight={400}>
            אוף! עדיין לא מצאנו לך חשבוניות..
          </Typography>
          <Typography variant="h6" fontSize={14} fontWeight={600}>
            אולי נחבר תיבות דואר לחשבון?
          </Typography>
        </Box>
        <Button
          variant="contained"
          sx={{
            [`& .${buttonClasses.startIcon}`]: {
              margin: '0 0 0 8px !important',
            },
          }}
          startIcon={<AddIcon />}
          onClick={goToInboxes}
        >
          הוסף תיבת דואר
        </Button>
      </Box>
    </PaperCard>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToInboxes: () => {
    dispatch(routingOnRouteRequest({ path: Routes.Inbox }));
  },
});

export default connect(null, mapDispatchToProps)(ReceiptsEmptyView);
